export default __webpack_public_path__ + "assets/01n.9ed9031b.svg";